import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Contract, Project, Activity, PaginatedResponse, ApiResponse } from '@com.maessa.payroll.frontend/models';

@Injectable({ providedIn: 'root' })
export class OottApiService extends BaseApiService {
  getContracts(filters?: { site_id?: number; active?: boolean }): Observable<PaginatedResponse<Contract>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<Contract>>(`${this.baseUrl}/contracts`, params);
  }

  createContract(payload: Partial<Contract>): Observable<ApiResponse<Contract>> {
    return this.post<ApiResponse<Contract>>(`${this.baseUrl}/contracts`, payload);
  }

  updateContract(id: number, payload: Partial<Contract>): Observable<ApiResponse<Contract>> {
    return this.put<ApiResponse<Contract>>(`${this.baseUrl}/contracts/${id}`, payload);
  }

  getProjects(filters?: { contract_id?: number; site_id?: number; active?: boolean }): Observable<PaginatedResponse<Project>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<Project>>(`${this.baseUrl}/projects`, params);
  }

  createProject(payload: Partial<Project>): Observable<ApiResponse<Project>> {
    return this.post<ApiResponse<Project>>(`${this.baseUrl}/projects`, payload);
  }

  updateProject(id: number, payload: Partial<Project>): Observable<ApiResponse<Project>> {
    return this.put<ApiResponse<Project>>(`${this.baseUrl}/projects/${id}`, payload);
  }

  getActivities(filters?: { project_id?: number; site_id?: number; active?: boolean }): Observable<PaginatedResponse<Activity>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<Activity>>(`${this.baseUrl}/activities`, params);
  }

  createActivity(payload: Partial<Activity>): Observable<ApiResponse<Activity>> {
    return this.post<ApiResponse<Activity>>(`${this.baseUrl}/activities`, payload);
  }

  updateActivity(id: number, payload: Partial<Activity>): Observable<ApiResponse<Activity>> {
    return this.put<ApiResponse<Activity>>(`${this.baseUrl}/activities/${id}`, payload);
  }
}
